<template>
  <b-card>
    <b-row>
      <b-col md="9">
        <b-form
          novalidate
          @submit.prevent="generateQRCode"
        >
          <validation-observer ref="formRef">
            <b-row>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Lat"
                  rules="required"
                >
                  <b-form-group
                    label="Lat"
                    label-for="qr-lat"
                  >
                    <b-form-input
                      id="qr-lat"
                      v-model="data.lat"
                      type="number"
                      placeholder="Lat"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Lng"
                  rules="required"
                >
                  <b-form-group
                    label="Lng"
                    label-for="qr-lng"
                  >
                    <b-form-input
                      id="qr-lng"
                      v-model="data.lng"
                      type="number"
                      placeholder="Lng"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Address"
                  rules="required"
                >
                  <b-form-group
                    label="Address"
                    label-for="qr-adress"
                  >
                    <b-form-input
                      id="qr-adress"
                      v-model="data.address"
                      placeholder="Address"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  #default="{ errors }"
                  name="Promo Code"
                  rules="required"
                >
                  <b-form-group
                    label="Promo Code"
                    label-for="qr-promo-code"
                  >
                    <b-form-input
                      id="qr-promo-code"
                      v-model="data.promo"
                      placeholder="Promo Code"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <b-button
                  variant="primary"
                  type="submit"
                  class="mr-2"
                >
                  Generate QR Code
                </b-button>
                <b-button
                  v-if="QRGenerated"
                  variant="success"
                  @click="downloadQRCode"
                >
                  Download QR Code
                </b-button>
              </b-col>
            </b-row>
          </validation-observer>
        </b-form>
      </b-col>
      <b-col md="3">
        <canvas
          ref="qrcode"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { getCurrentInstance, ref } from '@vue/composition-api'
import QRCode from 'qrcode'
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BForm,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    BFormInput,
  },
  setup() {
    const data = ref({
      lat: null,
      lng: null,
      address: null,
      promo: null,
    })

    const formRef = ref(null)
    const QRGenerated = ref(false)
    const instance = getCurrentInstance()
    const generateQRCode = async () => {
      try {
        const res = await formRef.value.validate()
        if (!res) return
        const addressTemp = encodeURIComponent(data.value.address)
        const str = `https://petraride.com/landing-page?latLng=${data.value.lat},${data.value.lng}&addressName=${addressTemp}&promoCode=${data.value.promo}`
        await QRCode.toCanvas(
          instance.refs.qrcode,
          str,
          { width: 300 },
          err => {
            console.log(err)
          },
        )
        QRGenerated.value = true
      } catch (err) {
        console.error(err)
      }
    }

    const downloadQRCode = () => {
      const canvas = instance.refs.qrcode

      // Create an off-screen canvas
      const offScreenCanvas = document.createElement('canvas')
      const context = offScreenCanvas.getContext('2d')

      // Set the dimensions of the off-screen canvas
      const scaleFactor = 4 // Adjust the scaling factor as needed
      offScreenCanvas.width = canvas.width * scaleFactor
      offScreenCanvas.height = canvas.height * scaleFactor

      // Draw the original canvas content onto the off-screen canvas at a higher resolution
      context.scale(scaleFactor, scaleFactor)
      context.drawImage(canvas, 0, 0)

      // Convert the off-screen canvas to a data URL
      const url = offScreenCanvas.toDataURL('image/png')

      // Download the image
      const link = document.createElement('a')
      link.href = url
      link.download = 'qrcode.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      // const url = canvas.toDataURL('image/png')
      // const link = document.createElement('a')
      // link.href = url
      // link.download = 'qrcode.png'
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
    }

    return {
      data,
      required,
      downloadQRCode,
      generateQRCode,
      QRGenerated,
      formRef,
    }
  },
}
</script>
